// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"180":"App","957":"views-app"}[chunkId] || chunkId) + "." + {"180":"d3f11227","527":"1c7a601c","577":"2986f47a","957":"78b1c0ef"}[chunkId] + ".chunk.css";
};